// src/pages/MyBooking.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import './MyBooking.css';

const CAPI = '/customer-api.php';
const LOGO_B64 = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4QAqRXhpZgAASUkqAAgAAAABADEBAgAHAAAAGgAAAAAAAABHb29nbGUAAP/bAIQAAwICCAgICAgICAgICAgICAgIBggICAgICAgIBwgICAgICAgICAgICAYICAgICggICAgKCQkICAsNCggNCAgKCAEDBAQGBQYIBgYKCAoICggICAgKCAgICAgICAgICAgICAgICggICAgICAgICAgICAgICAgICAgICAgICAgICAgI/8AAEQgBCQEJAwERAAIRAQMRAf/EAB0AAQACAgMBAQAAAAAAAAAAAAAGBwEFAgQIAwn/xABEEAACAgEDAgMGAQgGCAcAAAABAgADBAUREgYhBxMxCBQiMkFRYQkVIyRCUpGhFmJxcoGCNEOisbPR0vAzNURFU3ST/8QAGwEBAAIDAQEAAAAAAAAAAAAAAAQFAgMGAQf/xAA9EQACAQMCAwUEBwYHAQEAAAAAAQIDBBEhMQUSQRMiUWFxMoGRsQYUUmJyocEVIzNC0fBTgpKiwuHxYzX/2gAMAwEAAhEDEQA/AP1TgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAIAgCAf/2Q==';
const WA   = 'https://wa.me/447487672075';
const TEL  = 'tel:02030190055';

// ── SVG Icons ──────────────────────────────────────────────────────────────
const Ic = {
  Plane:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/></svg>,
  Hotel:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  Users:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  Payment:  ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>,
  Check:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><polyline points="20 6 9 17 4 12"/></svg>,
  Edit:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  Phone:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
  Share:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>,
  Star:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
  Copy:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>,
  WA:       ()=><svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.985-1.349A9.954 9.954 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2z"/></svg>,
  Lock:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
  Bus:      ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M8 6v6"/><path d="M15 6v6"/><path d="M2 12h19.6"/><path d="M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3"/><circle cx="7" cy="18" r="2"/><path d="M9 18h5"/><circle cx="16" cy="18" r="2"/></svg>,
  Calendar: ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  Gift:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>,
  Alert:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  Doc:      ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
  Heart:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>,
  ChevR:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><polyline points="9 18 15 12 9 6"/></svg>,
  Download: ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  File:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
  Bag:      ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>,
  Passport: ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><rect x="3" y="2" width="18" height="20" rx="2"/><circle cx="12" cy="10" r="3"/><path d="M7 22v-2a5 5 0 0 1 10 0v2"/></svg>,
  Map:      ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/><line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/></svg>,
  Sun:      ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>,
};

// ── Date helpers ────────────────────────────────────────────────────────────
const MN = {Jan:0,Feb:1,Mar:2,Apr:3,May:4,Jun:5,Jul:6,Aug:7,Sep:8,Oct:9,Nov:10,Dec:11};
function parseBookingDate(s) {
  if (!s) return null;
  const p = s.trim().split(/[\s,]+/);
  if (p.length >= 3 && MN[p[1]] !== undefined) return new Date(parseInt(p[2]), MN[p[1]], parseInt(p[0]));
  const d = new Date(s); return isNaN(d) ? null : d;
}
function daysUntil(s) {
  const d = parseBookingDate(s); if (!d) return null;
  const n = new Date(); n.setHours(0,0,0,0);
  return Math.round((d - n) / 86400000);
}
function isPast(s) { const d = daysUntil(s); return d !== null && d < 0; }

// ── Request type labels (for the reply thread) ──────────────────────────────
const REQUEST_TYPE_LABELS = {
  amendment: 'Name / Room Amendment',
  transfer_quote: 'Transfer Quote',
  extras: 'Add Extras',
  special: 'Special Request',
  payment_plan: 'Payment Plan',
  message: 'Message',
};

function timeAgo(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr.replace(' ', 'T'));
  if (isNaN(d)) return dateStr;
  const diff = Date.now() - d.getTime();
  const mins = Math.round(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return d.toLocaleDateString('en-GB', { day:'numeric', month:'short', year:'numeric' });
}

// ── Section nav config ──────────────────────────────────────────────────────
const SECTIONS = [
  { id:'overview',  label:'Overview',  Icon: Ic.Sun      },
  { id:'hotel',     label:'Hotel',     Icon: Ic.Hotel    },
  { id:'travellers',label:'Travellers',Icon: Ic.Users    },
  { id:'payment',   label:'Payment',   Icon: Ic.Payment  },

  { id:'manage',    label:'Manage',    Icon: Ic.Edit     },
  { id:'contact',   label:'Contact',   Icon: Ic.Phone    },
  { id:'plan',      label:'Plan Next',  Icon: Ic.Gift     },
  { id:'share',     label:'Share',     Icon: Ic.Share    },
];

const REQUEST_TYPES = [
  { id:'amendment',      label:'Name / Room Amendment',   placeholder:'e.g. Correct spelling of passenger name from SMYTH to SMITH, or request room upgrade' },
  { id:'transfer_quote', label:'🚌 Add Transfers (Discounted)', placeholder:'e.g. Return airport transfers for 4 adults from Manchester Airport to hotel. Please send your best price.' },
  { id:'extras',         label:'Add Extras',               placeholder:'e.g. Airport parking at Manchester, travel insurance quote, room upgrade' },
  { id:'special',        label:'Special Request',          placeholder:'e.g. Gluten-free meals, accessible room required, celebrating anniversary' },
  { id:'payment_plan',   label:'Change Payment Plan',      placeholder:'e.g. Would like to split remaining balance into two payments — £150 on 1 Jun and £200 on 1 Jul' },
  { id:'message',        label:'Message Our Team',         placeholder:'Ask us anything about your booking...' },
];

// ────────────────────────────────────────────────────────────────────────────
export default function MyBooking() {
  // Verify state
  const [form, setForm]       = useState({ ref:'', surname:'', mobile4:'' });
  const [verErr, setVerErr]   = useState('');
  const [verLoading, setVerL] = useState(false);

  // Portal state
  const [step, setStep]       = useState('verify'); // 'verify' | 'portal' | 'post'
  const [creds, setCreds]     = useState(null);     // {ref, mobile4}
  const [booking, setBooking] = useState(null);
  const [loadErr, setLoadErr] = useState('');

  // UI
  const [activeSection, setActive] = useState('overview');
  const [countdown, setCountdown]  = useState(null);
  const [copied, setCopied]        = useState(false);

  // Request form
  const [reqType, setReqType]   = useState('');
  const [reqSubj, setReqSubj]   = useState('');
  const [reqMsg, setReqMsg]     = useState('');
  const [reqSending, setReqSnd] = useState(false);
  const [reqDone, setReqDone]   = useState('');
  const [pdfLoading, setPdfLoading] = useState(false);
  const [prevBookings, setPrevBookings] = useState([]);
  // Future holiday plan
  const [plan, setPlan]         = useState({ destination:'', dateFrom:'', dateTo:'', airport:'', adults:'', kids:'', kidAges:'', budget:'' });
  const [planSent, setPlanSent] = useState(false);
  const [planSending, setPlanSndg] = useState(false);
  const [planErr, setPlanErr]   = useState('');
  const [reqErr, setReqErr]     = useState('');

  // My requests & staff replies
  const [myRequests, setMyRequests]     = useState([]);
  const [unreadReplies, setUnreadReplies] = useState(0);
  const [reqsLoading, setReqsLoading]   = useState(false);

  // Passport checker

  // ── Countdown timer ──────────────────────────────────────────────────────
  useEffect(() => {
    if (!booking) return;
    const target = parseBookingDate(booking.checkIn);
    if (!target) return;
    const tick = () => {
      const now = new Date();
      const diff = target - now;
      if (diff <= 0) { setCountdown({ past: true }); return; }
      setCountdown({
        days:  Math.floor(diff / 86400000),
        hours: Math.floor((diff % 86400000) / 3600000),
        mins:  Math.floor((diff % 3600000) / 60000),
        secs:  Math.floor((diff % 60000) / 1000),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [booking]);

  // ── Verify ───────────────────────────────────────────────────────────────
  const handleVerify = async e => {
    e.preventDefault();
    setVerErr(''); setVerL(true);
    try {
      const r = await fetch(`${CAPI}?action=verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ref: form.ref.trim().toUpperCase(), surname: form.surname.trim().toUpperCase(), mobile4: form.mobile4.trim() }),
      });
      const d = await r.json();
      if (!d.ok) { setVerErr(d.error || 'Verification failed'); setVerL(false); return; }
      const c = { ref: form.ref.trim().toUpperCase(), mobile4: form.mobile4.trim() };
      setCreds(c);
      await loadBooking(c);
    } catch { setVerErr('Network error. Please check your connection.'); setVerL(false); }
  };

  // ── Load booking ─────────────────────────────────────────────────────────
  const loadBooking = async (c) => {
    setLoadErr('');
    try {
      const r = await fetch(`${CAPI}?action=booking&ref=${c.ref}&m4=${c.mobile4}`);
      const d = await r.json();
      if (!d.ok) { setLoadErr(d.error || 'Failed to load booking'); setVerL(false); return; }
      setBooking(d.booking);
      // Fetch previous bookings by same customer
      if (d.booking?.email || d.booking?.mobile) {
        fetchPrevBookings(d.booking.ref, d.booking.mobile);
      }
      // Fetch this customer's requests + any staff replies
      loadMyRequests(c);
      const postTravel = isPast(d.booking.checkOut);
      setStep(postTravel ? 'post' : 'portal');
    } catch { setLoadErr('Network error.'); }
    setVerL(false);
  };

  // ── My requests / staff replies ──────────────────────────────────────────
  const loadMyRequests = async (c) => {
    setReqsLoading(true);
    try {
      const r = await fetch(`${CAPI}?action=my_requests&ref=${c.ref}&m4=${c.mobile4}`);
      const d = await r.json();
      if (d.ok) {
        setMyRequests(d.requests || []);
        setUnreadReplies(d.unread || 0);
      }
    } catch (e) {}
    setReqsLoading(false);
  };

  const markReplySeen = async (id) => {
    if (!creds) return;
    try {
      await fetch(`${CAPI}?action=mark_seen`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ref: creds.ref, m4: creds.mobile4, id }),
      });
      setMyRequests(rs => rs.map(r => r.id === id ? { ...r, customer_seen: 1 } : r));
      setUnreadReplies(n => Math.max(0, n - 1));
    } catch (e) {}
  };

  // Mark unread replies as seen shortly after the requests list renders
  useEffect(() => {
    if (!myRequests.length) return;
    const toMark = myRequests.filter(r => r.staff_reply && Number(r.customer_seen) === 0);
    if (!toMark.length) return;
    const t = setTimeout(() => { toMark.forEach(r => markReplySeen(r.id)); }, 1500);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myRequests.length]);

  // ── Submit request ───────────────────────────────────────────────────────
  const submitRequest = async () => {
    if (!reqType || !reqMsg.trim()) { setReqErr('Please select a type and enter your message.'); return; }
    setReqSnd(true); setReqErr(''); setReqDone('');
    try {
      const r = await fetch(`${CAPI}?action=request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ref: creds.ref, m4: creds.mobile4, type: reqType, subject: reqSubj, message: reqMsg }),
      });
      const d = await r.json();
      if (!d.ok) { setReqErr(d.error || 'Submission failed'); }
      else {
        setReqDone(d.msg); setReqType(''); setReqSubj(''); setReqMsg('');
        loadMyRequests(creds); // refresh thread so the new request shows up
      }
    } catch { setReqErr('Network error.'); }
    setReqSnd(false);
  };

  // ── Copy referral code ───────────────────────────────────────────────────
  const copyCode = () => {
    const code = booking?.referral?.code;
    if (!code) return;
    navigator.clipboard.writeText(code).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); });
  };

  // ── Passport checker ─────────────────────────────────────────────────────

  // ── Section scroll ────────────────────────────────────────────────────────
  const scrollTo = id => {
    setActive(id);
    const el = document.getElementById(`mb-sec-${id}`);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // ── Submit future plan ────────────────────────────────────────────────────
  const submitPlan = async () => {
    if (!plan.destination || !plan.dateFrom) { setPlanErr('Please enter at least a destination and travel dates.'); return; }
    setPlanSndg(true); setPlanErr('');
    const msg = [
      `Destination: ${plan.destination}`,
      `Travel Dates: ${plan.dateFrom}${plan.dateTo ? ' — ' + plan.dateTo : ''}`,
      `Departure Airport: ${plan.airport || 'Not specified'}`,
      `Adults: ${plan.adults || 'Not specified'}`,
      plan.kids && plan.kids !== '0' ? `Children: ${plan.kids} (Ages: ${plan.kidAges || 'not specified'})` : '',
      `Budget: ${plan.budget ? '£' + plan.budget : 'Not specified'}`,
      `Referral Code: ${booking.referral?.code || 'N/A'}`,
    ].filter(Boolean).join('\n');
    try {
      const r = await fetch(`${CAPI}?action=request`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ref: creds.ref, m4: creds.mobile4, type: 'message', subject: 'Future Holiday Plan Request', message: msg }),
      });
      const d = await r.json();
      if (d.ok) setPlanSent(true);
      else setPlanErr(d.error || 'Submission failed. Please try again.');
    } catch { setPlanErr('Network error. Please try again.'); }
    setPlanSndg(false);
  };


  // ── Previous Bookings ────────────────────────────────────────────────────────
  const fetchPrevBookings = async (currentRef, mobile) => {
    try {
      const m4 = (mobile||'').replace(/\D/g,'').slice(-4);
      if (!m4 || m4.length < 4) return;
      // Pass history=1 flag — customer-api returns previous bookings with same mobile
      const r = await fetch(`${CAPI}?action=history&ref=${encodeURIComponent(currentRef)}&m4=${encodeURIComponent(m4)}`);
      if (!r.ok) return;
      const d = await r.json();
      if (Array.isArray(d)) setPrevBookings(d.filter(b => b.ref !== currentRef).slice(0, 3));
    } catch(e) {}
  };

  // ── Customer Invoice PDF ─────────────────────────────────────────────────
  const downloadInvoice = async () => {
    if (pdfLoading) return;
    setPdfLoading(true);
    // Dynamically load jsPDF
    if (!window.jspdf) {
      await new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
        s.onload = resolve; s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    try {
      const { jsPDF } = window.jspdf;
      const doc = new jsPDF({ unit: 'mm', format: 'a4' });
      const W = 210, M = 14, CW = W - M * 2;
      let y = M;
      const sf = (v, n = 60) => String(v || '').substring(0, n);

      const MNS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      const MNL = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      const fmtDate = s => {
        if (!s) return '';
        const iso = String(s).match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (iso) return parseInt(iso[3]) + ' ' + MNL[parseInt(iso[2]) - 1] + ' ' + iso[1];
        const p = String(s).trim().replace(/,/g, '').split(/\s+/);
        const mn = {Jan:0,Feb:1,Mar:2,Apr:3,May:4,Jun:5,Jul:6,Aug:7,Sep:8,Oct:9,Nov:10,Dec:11,
          January:0,February:1,March:2,April:3,June:5,July:6,August:7,September:8,October:9,November:10,December:11};
        if (p.length >= 3 && mn[p[1]] !== undefined) return p[0] + ' ' + MNL[mn[p[1]]] + ' ' + p[2];
        return s;
      };

      // ── HEADER ──────────────────────────────────────────────────────────
      doc.setFillColor(15, 23, 42);
      doc.rect(0, 0, W, 44, 'F');
      doc.setFillColor(212, 168, 67);
      doc.rect(0, 44, W, 1.2, 'F');

      // Logo box
      doc.setFillColor(255, 255, 255);
      doc.roundedRect(M, 6, 28, 28, 3, 3, 'F');
      try {
        doc.addImage(LOGO_B64, 'JPEG', M + 1, 7, 26, 26);
      } catch (e) {
        doc.setFontSize(11); doc.setFont('helvetica', 'bold'); doc.setTextColor(15, 23, 42);
        doc.text('BH', M + 14, 22, { align: 'center' });
      }

      // INVOICE header text
      doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(100, 116, 139);
      doc.text('INVOICE', W - M, 13, { align: 'right' });
      doc.setFontSize(20); doc.setFont('helvetica', 'bold'); doc.setTextColor(255, 255, 255);
      doc.text(sf(booking.ref, 12), W - M, 24, { align: 'right' });
      doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(148, 163, 184);
      doc.text(fmtDate(booking.date), W - M, 31, { align: 'right' });
      y = 50;

      // ── FROM / TO ──────────────────────────────────────────────────────
      const BW = (CW - 5) / 2;
      // Pre-calculate TO box height so it never overflows
      const cleanCustName2 = (booking.customer||'').replace(/\s+\d{1,2}[.\/]\d{1,2}[.\/]\d{2,4}$/, '').trim();
      const tNames2 = booking.travellersNames
        ? booking.travellersNames.split(',').map(n => n.trim().replace(/\s+\d{1,2}[.\/]\d{1,2}[.\/]\d{2,4}$/, '').trim()).filter(Boolean)
        : [];
      const toRows = tNames2.length + (booking.mobile?1:0) + (booking.email?1:0) + 1 + (booking.agentName?1:0);
      const toH = Math.max(44, 18 + toRows * 5.5 + 6);

      // FROM box — matches TO height
      doc.setFillColor(248, 250, 252); doc.setDrawColor(226, 232, 240);
      doc.roundedRect(M, y, BW, toH, 2, 2, 'FD');
      doc.setFontSize(6); doc.setFont('helvetica', 'bold'); doc.setTextColor(148, 163, 184);
      doc.text('FROM', M + 4, y + 6);
      doc.setFontSize(9.5); doc.setFont('helvetica', 'bold'); doc.setTextColor(15, 23, 42);
      doc.text('Broadway Holidays', M + 4, y + 13);
      doc.setFontSize(7); doc.setFont('helvetica', 'normal'); doc.setTextColor(100, 116, 139);
      doc.text('London, United Kingdom', M + 4, y + 19);
      doc.text('www.broadwayholidays.co.uk', M + 4, y + 24);
      doc.setFont('helvetica', 'bold'); doc.setTextColor(15, 23, 42);
      doc.text('Tel: 020 3019 0055', M + 4, y + 30);
      doc.setFont('helvetica', 'normal'); doc.setTextColor(37, 99, 235);
      doc.text('WhatsApp: 07487672075', M + 4, y + 36);

      // TO box — dynamic height, never overflows
      const tx = M + BW + 5;
      doc.setFillColor(240, 253, 244); doc.setDrawColor(187, 247, 208);
      doc.roundedRect(tx, y, BW, toH, 2, 2, 'FD');
      doc.setFontSize(6); doc.setFont('helvetica', 'bold'); doc.setTextColor(148, 163, 184);
      doc.text('TO', tx + 4, y + 6);
      doc.setFontSize(9.5); doc.setFont('helvetica', 'bold'); doc.setTextColor(15, 23, 42);
      doc.text(sf(cleanCustName2, 30), tx + 4, y + 13);
      // All traveller names
      doc.setFontSize(7); doc.setFont('helvetica', 'normal'); doc.setTextColor(71, 85, 105);
      let ty = y + 19;
      tNames2.forEach(name => {
        if (ty < y + toH - 4) { doc.text(sf(name, 34), tx + 4, ty); ty += 4.5; }
      });
      doc.setFontSize(7.5); doc.setFont('helvetica', 'normal');
      if (booking.mobile) {
        doc.setTextColor(15, 23, 42); doc.setFont('helvetica', 'bold');
        doc.text('Tel: ' + sf(booking.mobile), tx + 4, ty); ty += 5.5;
      }
      if (booking.email) {
        doc.setFont('helvetica', 'normal'); doc.setTextColor(37, 99, 235);
        doc.text(sf(booking.email, 32), tx + 4, ty); ty += 5.5;
      }
      doc.setFont('helvetica', 'normal'); doc.setTextColor(100, 116, 139);
      doc.text(sf('Ref: ' + booking.ref + (booking.type ? ' — ' + booking.type : ''), 36), tx + 4, ty); ty += 5.5;
      if (booking.agentName) {
        doc.setFont('helvetica', 'bold'); doc.setTextColor(124, 58, 237);
        doc.text('Agent: ' + sf(booking.agentName, 25), tx + 4, ty);
      }
      y += toH + 6;

      // ── ACCOMMODATION ──────────────────────────────────────────────────
      if (booking.hotelName) {
        const rows = [];
        if (booking.hotelAddress) rows.push(booking.hotelAddress);
        const rd = [];
        if (booking.roomType) rd.push('Room: ' + booking.roomType);
        if (booking.boardType) rd.push('Board: ' + booking.boardType);
        if (rd.length) rows.push(rd.join('  ·  '));
        if (booking.checkIn || booking.checkOut) {
          const dd = [];
          if (booking.checkIn) dd.push('Check-in: ' + fmtDate(booking.checkIn));
          if (booking.checkOut) dd.push('Check-out: ' + fmtDate(booking.checkOut));
          rows.push(dd.join('   '));
        }
        if (booking.travellers) rows.push('Guests: ' + booking.travellers);
        const hh = 16 + rows.length * 5 + 2;
        doc.setFillColor(240, 253, 244); doc.setDrawColor(187, 247, 208);
        doc.roundedRect(M, y, CW, hh, 2, 2, 'FD');
        doc.setFontSize(6); doc.setFont('helvetica', 'bold'); doc.setTextColor(5, 150, 105);
        doc.text('ACCOMMODATION', M + 4, y + 5.5);
        doc.setFontSize(10); doc.setFont('helvetica', 'bold'); doc.setTextColor(15, 23, 42);
        doc.text(sf(booking.hotelName, 52), M + 4, y + 12);
        doc.setFontSize(7.5); doc.setFont('helvetica', 'normal'); doc.setTextColor(100, 116, 139);
        let hy = y + 18; rows.forEach(r => { doc.text(sf(r, 72), M + 4, hy); hy += 5; });
        y += hh + 5;
      }

      // ── TRANSFERS (label only — no price) ──────────────────────────────
      if (booking.transfers && !['N/A','n/a','NA','na','No','no','None','none',''].includes((booking.transfers||'').trim())) {
        doc.setFillColor(255, 251, 235); doc.setDrawColor(253, 230, 138);
        doc.roundedRect(M, y, CW, 12, 2, 2, 'FD');
        doc.setFontSize(6); doc.setFont('helvetica', 'bold'); doc.setTextColor(217, 119, 6);
        doc.text('TRANSFERS', M + 4, y + 5);
        doc.setFontSize(8.5); doc.setFont('helvetica', 'bold'); doc.setTextColor(15, 23, 42);
        doc.text('Airport Transfers', M + 4, y + 10);
        y += 17;
      }

      // ── LINE ITEMS — Total Cost Only ───────────────────────────────────
      doc.setFillColor(15, 23, 42);
      doc.roundedRect(M, y, CW, 8, 2, 2, 'F');
      doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(255, 255, 255);
      doc.text('DESCRIPTION', M + 4, y + 5.5);
      doc.text('AMOUNT', M + CW - 4, y + 5.5, { align: 'right' });
      y += 8;
      // Single line: Holiday Package — Destination
      const itemDesc = (booking.hotelName || 'Holiday Package') + (booking.hotelAddress ? ' — ' + booking.hotelAddress : '');
      doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(15, 23, 42);
      doc.text(sf(itemDesc, 55), M + 4, y + 5.5);
      doc.setFont('helvetica', 'bold'); doc.setTextColor(21, 101, 192);
      doc.text('£' + (booking.tch || 0).toFixed(2), M + CW - 4, y + 5.5, { align: 'right' });
      doc.setDrawColor(241, 245, 249); doc.line(M, y + 8, M + CW, y + 8);
      y += 12;

      // ── TOTAL BAR ──────────────────────────────────────────────────────
      doc.setFillColor(15, 23, 42);
      doc.roundedRect(M, y, CW, 14, 2, 2, 'F');
      doc.setFontSize(7); doc.setFont('helvetica', 'normal'); doc.setTextColor(148, 163, 184);
      doc.text('TOTAL COST OF HOLIDAY', M + 4, y + 7);
      if (booking.type === 'Deposit') {
        doc.setFontSize(6.5); doc.setTextColor(13, 148, 136);
        doc.text('Deposit — see Instalment schedule', M + 4, y + 12);
      }
      doc.setFontSize(16); doc.setFont('helvetica', 'bold'); doc.setTextColor(240, 192, 67);
      doc.text('£' + (booking.tch || 0).toFixed(2), M + CW - 4, y + 11, { align: 'right' });
      y += 20;

      // ── INSTALMENT SCHEDULE ────────────────────────────────────────────
      const insts = booking.installments || [];
      if (insts.length && booking.type === 'Deposit') {
        if (y + 12 + insts.length * 11 > 275) { doc.addPage(); y = M; }
        const iH = 12 + insts.length * 11 + 2;
        doc.setFillColor(255, 251, 235); doc.setDrawColor(253, 230, 138);
        doc.roundedRect(M, y, CW, iH, 2, 2, 'FD');
        doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(217, 119, 6);
        doc.text('INSTALMENT SCHEDULE', M + 4, y + 7);
        let iy = y + 14;
        insts.forEach((inst, ii) => {
          const isPaid = inst.status === 'DONE';
          if (isPaid) { doc.setFillColor(240, 253, 244); doc.rect(M + 1, iy - 4, CW - 2, 10, 'F'); }
          doc.setFontSize(8.5); doc.setFont('helvetica', 'bold'); doc.setTextColor(15, 23, 42);
          doc.text('Payment ' + (ii + 1), M + 4, iy);
          if (isPaid) {
            doc.setFillColor(5, 150, 105); doc.roundedRect(M + 30, iy - 3.5, 14, 5, 1, 1, 'F');
            doc.setFontSize(6); doc.setFont('helvetica', 'bold'); doc.setTextColor(255, 255, 255);
            doc.text('PAID', M + 37, iy, { align: 'center' });
          } else {
            doc.setFontSize(7.5); doc.setFont('helvetica', 'normal'); doc.setTextColor(217, 119, 6);
            doc.text('Due ' + fmtDate(inst.due), M + 30, iy);
          }
          doc.setFontSize(10); doc.setFont('helvetica', 'bold');
          if (isPaid) { doc.setTextColor(5, 150, 105); } else { doc.setTextColor(217, 119, 6); }
          doc.text('£' + (Number(inst.amount) || 0).toFixed(2), M + CW - 4, iy, { align: 'right' });
          iy += 11;
        });
        y += iH + 6;
      }

      // ── FOOTER ─────────────────────────────────────────────────────────
      doc.setDrawColor(226, 232, 240); doc.line(M, 281, W - M, 281);
      doc.setFontSize(7); doc.setFont('helvetica', 'normal'); doc.setTextColor(148, 163, 184);
      doc.text('Broadway Holidays  •  www.broadwayholidays.co.uk  •  020 3019 0055  •  WhatsApp: 07487672075', W / 2, 285, { align: 'center' });

      doc.save(booking.ref + '-broadway-holidays-invoice.pdf');
    } catch (e) {
      console.error('PDF error:', e);
      alert('Could not generate PDF. Please try again.');
    }
    setPdfLoading(false);
  };


  // ────────────────────────────────────────────────────────────────────────
  // ── VERIFY SCREEN ────────────────────────────────────────────────────────
  if (step === 'verify') return (
    <div className="mb-root">
      <div className="mb-verify-bg">
        <div className="mb-verify-card">
          <div className="mb-verify-logo">
            <img src={logo} alt="Broadway Holidays"/>
            <div className="mb-verify-brand">
              <span className="mb-vb-broadway">Broadway</span>
              <span className="mb-vb-holidays">Holidays</span>
            </div>
          </div>
          <h1 className="mb-verify-title">My Booking</h1>
          <p className="mb-verify-sub">Enter your details to view your booking, manage requests and track your trip.</p>

          {(verErr || loadErr) && (
            <div className="mb-err-box">
              <Ic.Alert/> {verErr || loadErr}
            </div>
          )}

          <form onSubmit={handleVerify} className="mb-verify-form">
            <div className="mb-vfield">
              <label>Booking Reference</label>
              <input
                type="text"
                placeholder="e.g. BH2024"
                value={form.ref}
                onChange={e => setForm(f => ({ ...f, ref: e.target.value.toUpperCase() }))}
                required
                autoComplete="off"
              />
              <span className="mb-vhint">Found on your booking confirmation email</span>
            </div>
            <div className="mb-vfield">
              <label>Lead Passenger Surname</label>
              <input
                type="text"
                placeholder="e.g. SMITH"
                value={form.surname}
                onChange={e => setForm(f => ({ ...f, surname: e.target.value.toUpperCase() }))}
                required
                autoComplete="off"
              />
            </div>
            <div className="mb-vfield">
              <label>Last 4 Digits of Mobile</label>
              <input
                type="tel"
                placeholder="e.g. 4025"
                maxLength={4}
                value={form.mobile4}
                onChange={e => setForm(f => ({ ...f, mobile4: e.target.value.replace(/\D/g,'').slice(0,4) }))}
                required
                autoComplete="off"
              />
              <span className="mb-vhint">The number registered with your booking</span>
            </div>
            <button type="submit" className="mb-verify-btn" disabled={verLoading}>
              {verLoading ? <><span className="mb-spin"/> Verifying...</> : <><Ic.Lock/> Find My Booking</>}
            </button>
          </form>

          <div className="mb-verify-help">
            <p>Need help? Call us on <a href={TEL}>020 3019 0055</a> or <a href={WA} target="_blank" rel="noreferrer">WhatsApp us</a></p>
          </div>
        </div>
      </div>
    </div>
  );

  // ────────────────────────────────────────────────────────────────────────
  // ── POST-TRAVEL SCREEN ───────────────────────────────────────────────────
  if (step === 'post' && booking) {
    const firstName = (booking.customer || '').replace(/^(MR|MRS|MS|MISS|DR|MASTER)\s+/i,'').split(' ')[0];
    return (
      <div className="mb-root">
        <div className="mb-portal">
          {/* Header */}
          <div className="mb-portal-header mb-post-header">
            <img src={logo} alt="Broadway Holidays" className="mb-ph-logo"/>
            <div>
              <h2 className="mb-ph-title">Welcome back, {firstName}!</h2>
              <p className="mb-ph-sub">We hope you had a wonderful holiday.</p>
            </div>
          </div>

          <div className="mb-portal-body">
            
            {/* Refer a friend */}
            <div className="mb-refer-card">
              <div className="mb-refer-header">
                <div className="mb-refer-icon"><Ic.Gift/></div>
                <div>
                  <div className="mb-refer-title">Refer a Friend — Earn £99</div>
                  <div className="mb-refer-sub">Share your code · You both save £99</div>
                </div>
              </div>
              <p className="mb-refer-body">When a friend books and quotes your code, <strong>you both get £99 off</strong> your next Broadway Holidays trip.</p>
              {booking.referral?.code && (
                <div className="mb-ref-code-block">
                  <span className="mb-ref-code">{booking.referral.code}</span>
                  <button className="mb-icon-btn" onClick={copyCode}><Ic.Copy/>{copied ? 'Copied!' : 'Copy'}</button>
                </div>
              )}
              {booking.referral?.discount_available ? (
                <div className="mb-success-pill">Your referral discount of £99 is ready — mention it on your next booking!</div>
              ) : booking.referral?.used_count > 0 ? (
                <p className="mb-text-muted" style={{marginTop:8}}>Your code has been used {booking.referral.used_count} time{booking.referral.used_count>1?'s':''}.</p>
              ) : null}
            </div>

            {/* Rebook */}
            <div className="mb-card mb-card-navy">
              <h3 style={{color:'#fff'}}>Ready for your next adventure?</h3>
              <p style={{color:'rgba(255,255,255,0.8)'}}>Your agent {booking.agentName} is ready to help you plan your next holiday.</p>
              <div className="mb-btn-row">
                <a href="/" className="mb-btn mb-btn-white"><Ic.Plane/> Browse Holidays</a>
                <a href={WA} target="_blank" rel="noreferrer" className="mb-btn mb-btn-wa"><Ic.WA/> WhatsApp Us</a>
              </div>
            </div>

            <div className="mb-verify-help" style={{textAlign:'center',padding:'20px 0'}}>
              <button className="mb-link-btn" onClick={() => { setStep('verify'); setBooking(null); setCreds(null); }}>
                View a different booking
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ────────────────────────────────────────────────────────────────────────
  // ── MAIN PORTAL ──────────────────────────────────────────────────────────
  if (!booking) return null;

  const firstName   = (booking.customer || '').replace(/^(MR|MRS|MS|MISS|DR|MASTER)\s+/i,'').split(' ')[0];
  const isDeposit   = booking.type === 'Deposit';
  const daysLeft    = daysUntil(booking.checkIn);
  const totalPaid   = isDeposit
    ? (booking.installments || []).filter(i => i.status === 'DONE').reduce((s,i) => s + i.amount, 0)
    : booking.tch;
  const totalDue    = isDeposit
    ? (booking.installments || []).filter(i => i.status === 'DUE').reduce((s,i) => s + i.amount, 0)
    : 0;

  const hasTransfer = booking.transfers &&
    !['N/A','n/a','NA','na','No','no','None','none',''].includes((booking.transfers||'').trim());


  return (
    <div className="mb-root">
      <div className="mb-portal">

        {/* ── Top Banner ─────────────────────────────────────────────────── */}
        <div className="mb-hero">
          <div className="mb-hero-inner">
            <a href="/" className="mb-back-link" title="Back to Broadway Holidays">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><polyline points="15 18 9 12 15 6"/></svg>
            <span>Website</span>
          </a>
          <img src={logo} alt="Broadway Holidays" className="mb-hero-logo"/>
            <div className="mb-hero-text">
              <h1 className="mb-hero-title">
                {daysLeft !== null && daysLeft > 0
                  ? <><span className="mb-hero-wave"><Ic.Sun/></span> {firstName}, your holiday is in <span className="mb-hero-days">{daysLeft} day{daysLeft !== 1 ? 's' : ''}!</span></>
                  : <><span className="mb-hero-wave"><Ic.Plane/></span> Welcome, {firstName}!</>
                }
              </h1>
              <p className="mb-hero-sub">{booking.ref}  ·  {booking.hotelAddress || booking.hotelName}  ·  {booking.checkIn}</p>
            </div>
            {countdown && !countdown.past && (
              <div className="mb-countdown">
                {[['Days',countdown.days],['Hrs',countdown.hours],['Min',countdown.mins],['Sec',countdown.secs]].map(([l,v]) => (
                  <div key={l} className="mb-cd-unit">
                    <span className="mb-cd-num">{String(v).padStart(2,'0')}</span>
                    <span className="mb-cd-lbl">{l}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* ── Section nav ────────────────────────────────────────────────── */}
        <div className="mb-nav-wrap">
          <nav className="mb-sec-nav">
            {SECTIONS.map(s => (
              <button key={s.id} className={`mb-snav-btn${activeSection===s.id?' mb-snav-active':''}`} onClick={() => scrollTo(s.id)} style={{position:'relative'}}>
                <s.Icon/><span>{s.label}</span>
                {s.id === 'manage' && unreadReplies > 0 && (
                  <span style={{
                    position:'absolute', top:2, right:6, minWidth:16, height:16, borderRadius:8,
                    background:'#dc2626', color:'#fff', fontSize:10, fontWeight:700,
                    display:'flex', alignItems:'center', justifyContent:'center', padding:'0 4px', lineHeight:1
                  }}>{unreadReplies}</span>
                )}
              </button>
            ))}
          </nav>
        </div>

        <div className="mb-portal-body">

          {/* ── OVERVIEW ─────────────────────────────────────────────────── */}
          <section id="mb-sec-overview" className="mb-section">
            <h2 className="mb-sec-title"><Ic.Sun/> Booking Overview</h2>
            <div className="mb-overview-grid">
              <div className="mb-info-card">
                <div className="mb-info-label">Booking Ref</div>
                <div className="mb-info-val mb-ref-badge">{booking.ref}</div>
              </div>
              <div className="mb-info-card">
                <div className="mb-info-label">Booking Date</div>
                <div className="mb-info-val">{booking.date}</div>
              </div>
              <div className="mb-info-card">
                <div className="mb-info-label">Type</div>
                <div className={`mb-info-val mb-type-badge ${isDeposit ? 'mb-type-dep' : 'mb-type-paid'}`}>{booking.type}</div>
              </div>
              <div className="mb-info-card">
                <div className="mb-info-label">Your Agent</div>
                <div className="mb-info-val mb-agent-badge">{booking.agentName || 'Broadway Holidays'}</div>
              </div>
              <div className="mb-info-card">
                <div className="mb-info-label">Destination</div>
                <div className="mb-info-val">{booking.hotelAddress}</div>
              </div>
              <div className="mb-info-card">
                <div className="mb-info-label">Total Cost</div>
                <div className="mb-info-val mb-price">£{booking.tch?.toFixed(2)}</div>
              </div>
            </div>
          </section>

          {/* ── HOTEL & STAY ─────────────────────────────────────────────── */}
          <section id="mb-sec-hotel" className="mb-section">
            <h2 className="mb-sec-title"><Ic.Hotel/> Hotel & Stay</h2>
            <div className="mb-card">
              <div className="mb-hotel-name">{booking.hotelName}</div>
              <div className="mb-hotel-loc">{booking.hotelAddress}</div>
              <div className="mb-stay-grid">
                <div><div className="mb-info-label">Room Type</div><div className="mb-info-val">{booking.roomType || '—'}</div></div>
                <div><div className="mb-info-label">Board Basis</div><div className="mb-info-val">{booking.boardType || '—'}</div></div>
                <div><div className="mb-info-label">Check-In</div><div className="mb-info-val mb-date">{booking.checkIn}</div></div>
                <div><div className="mb-info-label">Check-Out</div><div className="mb-info-val mb-date">{booking.checkOut}</div></div>
                <div><div className="mb-info-label">Duration</div><div className="mb-info-val">{booking.checkIn && booking.checkOut ? (() => { const ci=new Date(booking.checkIn+' 00:00'), co=new Date(booking.checkOut+' 00:00'); const n=Math.round((co-ci)/86400000); return n>0?n+' night'+(n!==1?'s':''):'—'; })() : '—'}</div></div>

              </div>
            </div>

            {/* Transfer */}
            {hasTransfer ? (
              <div className="mb-transfer-badge">
                <div className="mb-tb-icon"><Ic.Bus/></div>
                <div className="mb-tb-info">
                  <div className="mb-tb-title">Airport Transfers</div>
                  <div className="mb-tb-sub">Return transfers included with your booking</div>
                </div>
                <span className="mb-tb-pill"><Ic.Check/> Included</span>
              </div>
            ) : (
              <div className="mb-add-transfer-card">
                <div className="mb-atc-icon-wrap"><Ic.Bus/></div>
                <div className="mb-atc-body">
                  <div className="mb-atc-title">Add Airport Transfers</div>
                  <div className="mb-atc-sub">Get a discounted transfer quote for your holiday</div>
                </div>
                <button
                  className="mb-btn mb-atc-btn"
                  onClick={() => {
                    document.getElementById('mb-sec-manage').scrollIntoView({behavior:'smooth'});
                    setTimeout(() => {
                      const btn = document.querySelector('[data-req="transfer_quote"]');
                      if (btn) btn.click();
                    }, 600);
                  }}
                >
                  Get Quote
                </button>
              </div>
            )}

          </section>

          {/* ── TRAVELLERS ───────────────────────────────────────────────── */}
          <section id="mb-sec-travellers" className="mb-section">
            <h2 className="mb-sec-title"><Ic.Users/> Your Travellers</h2>
            <div className="mb-card">
              <div className="mb-travellers-count">
                <Ic.Users/>
                <span>{booking.travellers || 'See below'}</span>
              </div>
              {booking.travellersNames && (
                <div className="mb-names-list">
                  {booking.travellersNames.split(',').map((n, i) => (
                    <div key={i} className="mb-name-pill">
                      <span className="mb-name-num">{i+1}</span>
                      {n.trim()}
                      {i === 0 && <span className="mb-lead-badge">Lead</span>}
                    </div>
                  ))}
                </div>
              )}
              <div className="mb-contact-strip">
                <div><div className="mb-info-label">Contact</div><div className="mb-info-val">{booking.mobile}</div></div>
                {booking.email && <div><div className="mb-info-label">Email</div><div className="mb-info-val">{booking.email}</div></div>}
              </div>
            </div>
          </section>

          {/* ── PAYMENT ──────────────────────────────────────────────────── */}
          <section id="mb-sec-payment" className="mb-section">
            <h2 className="mb-sec-title"><Ic.Payment/> Payment</h2>
            <div className="mb-card">
              {isDeposit ? (
                <>
                  <div className="mb-payment-summary">
                    <div className="mb-pay-row">
                      <span>Total Holiday Cost</span>
                      <span className="mb-price">£{booking.tch?.toFixed(2)}</span>
                    </div>
                    <div className="mb-pay-row mb-pay-paid">
                      <span>Paid to date</span>
                      <span className="mb-price-green">£{totalPaid.toFixed(2)}</span>
                    </div>
                    {totalDue > 0 && (
                      <div className="mb-pay-row mb-pay-due">
                        <span>Outstanding balance</span>
                        <span className="mb-price-amber">£{totalDue.toFixed(2)}</span>
                      </div>
                    )}
                  </div>
                  {totalDue > 0 && (
                    <div className="mb-balance-banner">
                      <Ic.Alert/>
                      <span>You have an outstanding balance of <strong>£{totalDue.toFixed(2)}</strong>. Please contact us to arrange payment.</span>
                    </div>
                  )}
                  <div className="mb-inst-title"><Ic.Calendar/> Instalment Schedule</div>
                  <div className="mb-inst-list">
                    {(booking.installments || []).map((inst, i) => (
                      <div key={i} className={`mb-inst-row ${inst.status === 'DONE' ? 'mb-inst-done' : 'mb-inst-due'}`}>
                        <div>
                          <div className="mb-inst-num">Instalment {inst.num}</div>
                          <div className="mb-inst-due-date">{inst.due || '—'}</div>
                        </div>
                        <div className="mb-inst-right">
                          <span className="mb-inst-amt">£{inst.amount?.toFixed(2)}</span>
                          <span className={`mb-status-pill ${inst.status==='DONE'?'mb-s-done':'mb-s-due'}`}>{inst.status}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mb-pay-actions">
                    <p className="mb-text-muted">To pay your balance or discuss your payment plan, contact our team:</p>
                    <div className="mb-btn-row">
                      <a href={WA} target="_blank" rel="noreferrer" className="mb-btn mb-btn-wa"><Ic.WA/> WhatsApp to Pay</a>
                      <a href={TEL} className="mb-btn mb-btn-outline"><Ic.Phone/> Call Us</a>
                    </div>
                  </div>
                </>
              ) : (
                <div className="mb-paid-badge">
                  <Ic.Check/>
                  <div>
                    <div className="mb-paid-title">Paid in Full</div>
                    <div className="mb-paid-amt">£{booking.tch?.toFixed(2)}</div>
                  </div>
                </div>
              )}

              {/* Download Invoice button — for all customers */}
              <div style={{marginTop:16,paddingTop:14,borderTop:'1px solid var(--mb-border)'}}>
                <button
                  className="mb-btn mb-btn-primary"
                  onClick={downloadInvoice}
                  disabled={pdfLoading}
                  style={{width:'100%',justifyContent:'center',gap:8}}
                >
                  {pdfLoading
                    ? <><span className="mb-spin"/> Generating PDF...</>
                    : <><Ic.Download/> Download My Invoice</>}
                </button>
                <p style={{fontSize:11,color:'var(--mb-muted)',textAlign:'center',marginTop:6}}>
                  Your booking confirmation as a PDF
                </p>
              </div>
            </div>
          </section>

          {/* ── MANAGE ───────────────────────────────────────────────────── */}
          <section id="mb-sec-manage" className="mb-section">
            <h2 className="mb-sec-title"><Ic.Edit/> Manage Booking</h2>
            <div className="mb-card mb-manage-card">
              {/* Manage header banner */}
              <div className="mb-manage-banner">
                <div className="mb-manage-banner-left">
                  <div className="mb-manage-banner-icon"><Ic.Edit/></div>
                  <div>
                    <div className="mb-manage-banner-title">Need to change something?</div>
                    <div className="mb-manage-banner-sub">Our team responds within 24 hours · <a href="tel:02030190055" style={{color:'#fff',fontWeight:700,textDecoration:'none'}}>020 3019 0055</a></div>
                  </div>
                </div>
              </div>
              {reqDone ? (
                <div className="mb-req-success"><Ic.Check/> {reqDone}</div>
              ) : (
                <>
                  <p className="mb-text-muted" style={{marginBottom:14}}>Select a request type below and tell us what you need:</p>
                  <div className="mb-req-types">
                    {REQUEST_TYPES.map(t => (
                      <button key={t.id} data-req={t.id} className={`mb-req-type-btn ${reqType===t.id?'mb-rt-active':''}`} onClick={() => { setReqType(t.id); setReqErr(''); }}>
                        {t.label}
                      </button>
                    ))}
                  </div>
                  {reqType && (
                    <div className="mb-req-form">
                      <input
                        className="mb-text-input"
                        placeholder="Subject (optional)"
                        value={reqSubj}
                        onChange={e => setReqSubj(e.target.value)}
                      />
                      <textarea
                        className="mb-textarea"
                        rows={4}
                        placeholder={REQUEST_TYPES.find(t=>t.id===reqType)?.placeholder || 'Describe your request...'}
                        value={reqMsg}
                        onChange={e => setReqMsg(e.target.value)}
                      />
                      {reqErr && <div className="mb-err-inline"><Ic.Alert/> {reqErr}</div>}
                      <button className="mb-btn mb-btn-primary" onClick={submitRequest} disabled={reqSending}>
                        {reqSending ? <><span className="mb-spin"/> Sending...</> : <><Ic.ChevR/> Submit Request</>}
                      </button>
                    </div>
                  )}
                </>
              )}

              {/* ── Previous requests + staff replies thread ──────────────── */}
              {myRequests.length > 0 && (
                <div style={{marginTop:22,paddingTop:18,borderTop:'1px solid var(--mb-border, #e2e8f0)'}}>
                  <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:12}}>
                    <span style={{fontSize:12,fontWeight:700,color:'#64748b',textTransform:'uppercase',letterSpacing:'0.5px'}}>
                      Your Requests & Messages
                    </span>
                    {reqsLoading && <span className="mb-spin" style={{width:12,height:12}}/>}
                  </div>
                  <div style={{display:'flex',flexDirection:'column',gap:12}}>
                    {myRequests.map(r => {
                      const hasReply = !!r.staff_reply;
                      const isUnread = hasReply && Number(r.customer_seen) === 0;
                      return (
                        <div key={r.id} style={{
                          border: isUnread ? '1px solid #93c5fd' : '1px solid #e2e8f0',
                          background: isUnread ? '#eff6ff' : '#f8fafc',
                          borderRadius: 10,
                          padding: 12,
                          position: 'relative',
                        }}>
                          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:8,flexWrap:'wrap'}}>
                            <div style={{display:'flex',alignItems:'center',gap:8}}>
                              <span style={{
                                fontSize:11, fontWeight:700, color:'#1e3a8a', background:'#dbeafe',
                                padding:'2px 8px', borderRadius:20,
                              }}>{REQUEST_TYPE_LABELS[r.type] || r.type}</span>
                              <span style={{
                                fontSize:10.5, fontWeight:700, textTransform:'uppercase', letterSpacing:'.3px',
                                color: r.status==='resolved' ? '#059669' : r.status==='in_progress' ? '#d97706' : '#64748b',
                              }}>{r.status === 'in_progress' ? 'In Progress' : r.status === 'resolved' ? 'Resolved' : 'New'}</span>
                            </div>
                            <span style={{fontSize:11,color:'#94a3b8'}}>{timeAgo(r.created_at)}</span>
                          </div>
                          {r.subject && <div style={{fontWeight:700,fontSize:13,color:'#0f172a',marginTop:6}}>{r.subject}</div>}
                          <div style={{fontSize:13,color:'#334155',marginTop:4,whiteSpace:'pre-wrap'}}>{r.message}</div>

                          {hasReply && (
                            <div style={{
                              marginTop:10, background:'#0f172a', color:'#fff', borderRadius:8,
                              padding:'10px 12px',
                            }}>
                              <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:4}}>
                                <img src={logo} alt="" style={{width:16,height:16,borderRadius:4,background:'#fff'}}/>
                                <span style={{fontSize:11,fontWeight:700,color:'#f0c040'}}>Broadway Holidays replied</span>
                                <span style={{fontSize:10,color:'#94a3b8',marginLeft:'auto'}}>{timeAgo(r.reply_at)}</span>
                              </div>
                              <div style={{fontSize:13,whiteSpace:'pre-wrap'}}>{r.staff_reply}</div>
                            </div>
                          )}

                          {isUnread && (
                            <span style={{
                              position:'absolute', top:-6, right:-6, width:10, height:10, borderRadius:'50%',
                              background:'#dc2626', border:'2px solid #fff',
                            }}/>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </section>

          {/* ── CONTACT ──────────────────────────────────────────────────── */}
          <section id="mb-sec-contact" className="mb-section">
            <h2 className="mb-sec-title"><Ic.Phone/> Contact & Support</h2>
            <div className="mb-contact-cards">
              <div className="mb-contact-card mb-cc-wa">
                <Ic.WA/>
                <div>
                  <div className="mb-cc-title">WhatsApp Us</div>
                  <div className="mb-cc-sub">Fast replies · 7 days a week</div>
                </div>
                <a href={`${WA}?text=Hi, my booking ref is ${booking.ref}. I need help with...`} target="_blank" rel="noreferrer" className="mb-btn mb-btn-wa">
                  Message
                </a>
              </div>
              <div className="mb-contact-card mb-cc-phone">
                <Ic.Phone/>
                <div>
                  <div className="mb-cc-title">Call Us</div>
                  <div className="mb-cc-sub">020 3019 0055</div>
                </div>
                <a href={TEL} className="mb-btn mb-btn-outline">Call Now</a>
              </div>
            </div>

            {/* Emergency card */}
            <div className="mb-emergency-card">
              <div className="mb-em-header"><Ic.Alert/> 24hr Emergency Contact</div>
              <div className="mb-em-body">
                <p>If you are experiencing an emergency during your trip, contact us immediately:</p>
                <a href={TEL} className="mb-em-number">020 3019 0055</a>
                <a href={WA} target="_blank" rel="noreferrer" className="mb-em-wa"><Ic.WA/> WhatsApp Emergency Line</a>
                <p className="mb-em-note">Reference your booking: <strong>{booking.ref}</strong></p>
              </div>
            </div>
          </section>

          {/* ── HOLIDAY HISTORY ──────────────────────────────────────── */}
          {prevBookings.length > 0 && (
          <section className="mb-section">
            <h2 className="mb-sec-title"><Ic.Plane/> Your Journey With Us</h2>
            <div className="mb-card" style={{padding:0,overflow:'hidden'}}>
              <div style={{background:'linear-gradient(135deg,#0f172a,#1e3a8a)',padding:'12px 18px'}}>
                <div style={{fontSize:11,fontWeight:700,color:'#94a3b8',textTransform:'uppercase',letterSpacing:'0.5px'}}>Previous Holidays With Broadway Holidays</div>
              </div>
              {prevBookings.map((pb,i) => (
                <div key={i} style={{padding:'14px 18px',borderBottom:i<prevBookings.length-1?'1px solid #f1f5f9':'none',display:'flex',alignItems:'center',gap:12}}>
                  <div style={{width:40,height:40,borderRadius:9,background:'#eff6ff',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,color:'#1565c0'}}>
                    <Ic.Plane/>
                  </div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:700,fontSize:13,color:'#0f172a',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{pb.hotelName||pb.hotelAddress||'Holiday Package'}</div>
                    <div style={{fontSize:11.5,color:'#64748b',marginTop:2}}>{pb.ref}{pb.checkIn?` · ${pb.checkIn}`:''}{pb.hotelAddress?` · ${pb.hotelAddress}`:''}</div>
                  </div>
                  <span style={{fontSize:11,fontWeight:700,color:'#059669',background:'#d1fae5',padding:'3px 10px',borderRadius:20,flexShrink:0}}>Past Holiday</span>
                </div>
              ))}
            </div>
          </section>
          )}

          {/* ── FUTURE HOLIDAY PLAN ─────────────────────────────────── */}
          <section id="mb-sec-plan" className="mb-section">
            <h2 className="mb-sec-title"><Ic.Gift/> Plan Your Next Holiday</h2>
            <div className="mb-card mb-plan-card">
              {/* Discount banner */}
              <div className="mb-plan-banner">
                <div className="mb-plan-banner-icon"><Ic.Gift/></div>
                <div style={{flex:1}}>
                  <div className="mb-plan-banner-title">Get up to £99 off your next booking!</div>
                  <div className="mb-plan-banner-sub">
                    Tell us where you want to go next and we'll find you the best deal.
                    {booking.referral?.code && <> Your referral code <strong style={{color:'#f0c040'}}>{booking.referral.code}</strong> gives you up to £99 off.</>}
                  </div>
                </div>
              </div>

              {planSent ? (
                <div className="mb-req-success" style={{marginTop:16}}>
                  <Ic.Check/> Request sent! Our team will be in touch with the best deals for your trip.
                </div>
              ) : (
                <div className="mb-plan-form">
                  <div className="mb-plan-grid">
                    {/* Row 1: Destination full width */}
                    <div className="mb-pfield mb-pfield-full">
                      <label><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,color:'var(--mb-blue)'}}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg> Where do you want to go?</label>
                      <input type="text" placeholder="e.g. Dubai, Tenerife, Maldives, Turkey..." value={plan.destination}
                        onChange={e => setPlan(p=>({...p, destination:e.target.value}))}/>
                    </div>
                    {/* Row 2: Dates */}
                    <div className="mb-pfield">
                      <label><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,color:'var(--mb-blue)'}}><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg> Departure Date</label>
                      <input type="date" value={plan.dateFrom} onChange={e => setPlan(p=>({...p, dateFrom:e.target.value}))}/>
                    </div>
                    <div className="mb-pfield">
                      <label><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,color:'var(--mb-blue)'}}><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg> Return Date</label>
                      <input type="date" value={plan.dateTo} onChange={e => setPlan(p=>({...p, dateTo:e.target.value}))}/>
                    </div>
                    {/* Row 3: Airport + Travellers */}
                    <div className="mb-pfield">
                      <label><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,color:'var(--mb-blue)'}}><path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/></svg> Departure Airport</label>
                      <input type="text" placeholder="e.g. Manchester, Heathrow, Gatwick" value={plan.airport}
                        onChange={e => setPlan(p=>({...p, airport:e.target.value}))}/>
                    </div>
                    <div className="mb-pfield" style={{display:'flex', gap:8}}>
                      <div style={{flex:1}}>
                        <label><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,color:'var(--mb-blue)'}}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg> Adults</label>
                        <input type="number" min="1" max="20" placeholder="2" value={plan.adults}
                          onChange={e => setPlan(p=>({...p, adults:e.target.value}))}/>
                      </div>
                      <div style={{flex:1}}>
                        <label><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,color:'var(--mb-blue)'}}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg> Children</label>
                        <input type="number" min="0" max="10" placeholder="0" value={plan.kids}
                          onChange={e => setPlan(p=>({...p, kids:e.target.value}))}/>
                      </div>
                    </div>
                    {plan.kids && parseInt(plan.kids) > 0 && (
                      <div className="mb-pfield mb-pfield-full">
                        <label>Children's Ages <span className="mb-plan-hint">e.g. 5, 8, 12</span></label>
                        <input type="text" placeholder="e.g. 5, 8, 12" value={plan.kidAges}
                          onChange={e => setPlan(p=>({...p, kidAges:e.target.value}))}/>
                      </div>
                    )}
                    {/* Budget */}
                    <div className="mb-pfield mb-pfield-full">
                      <label><svg viewBox="0 0 320 512" width="11" height="13" fill="currentColor" style={{flexShrink:0,color:'var(--mb-blue)'}}><path d="M159.9 32c-44.3 0-80 35.7-80 80 0 13.3 10.7 24 24 24s24-10.7 24-24c0-17.7 14.3-32 32-32 17.6 0 32 14.3 32 32v16H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h128v32H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h144v136c0 13.3 10.7 24 24 24s24-10.7 24-24V224h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96v-32h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H272v-16c0-44.3-35.7-80-80-80z"/></svg> Your Budget <span className="mb-plan-hint">per person or total — your choice</span></label>
                      <div className="mb-budget-row">
                        <span className="mb-budget-pound">£</span>
                        <input type="number" min="100" placeholder="e.g. 1500" value={plan.budget}
                          onChange={e => setPlan(p=>({...p, budget:e.target.value}))}/>
                      </div>
                    </div>
                  </div>
                  {planErr && <div className="mb-err-inline" style={{marginTop:10}}><Ic.Alert/> {planErr}</div>}
                  <button className="mb-btn mb-btn-primary mb-plan-submit" onClick={submitPlan} disabled={planSending}>
                    {planSending ? <><span className="mb-spin"/> Sending...</> : <><Ic.Gift/> Send My Holiday Plan</>}
                  </button>
                  <p className="mb-plan-note">Our team will call or WhatsApp you with tailored options. No obligation.</p>
                </div>
              )}
            </div>
          </section>

          {/* ── SHARE ────────────────────────────────────────────────────── */}
          <section id="mb-sec-share" className="mb-section">
            <h2 className="mb-sec-title"><Ic.Share/> Share & Refer</h2>

            {/* Countdown share card */}
            <div className="mb-card mb-share-card-preview">
              <div className="mb-sc-inner">
                <img src={logo} alt="Broadway Holidays" className="mb-sc-logo"/>
                <div className="mb-sc-title">{daysLeft !== null && daysLeft > 0 ? `${daysLeft} days to go!` : 'We\'re off!'}</div>
                <div className="mb-sc-dest"><Ic.Map/> {booking.hotelAddress}</div>
                <div className="mb-sc-dates">{booking.checkIn} — {booking.checkOut}</div>
                <div className="mb-sc-brand">Booked with Broadway Holidays</div>
              </div>
              <div className="mb-share-actions">
                <button className="mb-btn mb-btn-outline" onClick={() => {
                  const text = `${daysLeft > 0 ? `${daysLeft} days until my holiday` : 'Off on holiday!'} to ${booking.hotelAddress}! Booked with Broadway Holidays broadwayholidays.co.uk`;
                  if (navigator.share) navigator.share({ text });
                  else { navigator.clipboard.writeText(text); alert('Text copied to clipboard!'); }
                }}>
                  <Ic.Share/> Share
                </button>
                <a href={`https://wa.me/?text=${encodeURIComponent(`${daysLeft > 0 ? `${daysLeft} days until my holiday` : "Off on holiday!"} to ${booking.hotelAddress}! Booked with Broadway Holidays broadwayholidays.co.uk`)}`}
                  target="_blank" rel="noreferrer" className="mb-btn mb-btn-wa">
                  <Ic.WA/> Share on WhatsApp
                </a>
              </div>
            </div>

            {/* Referral */}
            <div className="mb-card" style={{marginTop:12}}>
              <div className="mb-sec-hdr"><Ic.Gift/><span>Refer a Friend — Earn £99</span></div>
              <p className="mb-text-muted">Share your unique code. When a friend books and quotes it, you <strong>both save £99</strong> on your next holiday with Broadway Holidays.</p>
              {booking.referral?.code && (
                <>
                  <div className="mb-ref-code-block">
                    <span className="mb-ref-code">{booking.referral.code}</span>
                    <button className="mb-icon-btn" onClick={copyCode}><Ic.Copy/>{copied ? 'Copied!' : 'Copy'}</button>
                  </div>
                  <div className="mb-btn-row" style={{marginTop:12}}>
                    <a href={`https://wa.me/?text=${encodeURIComponent(`Book your holiday with Broadway Holidays and use my code ${booking.referral.code} — we both get £99 off! broadwayholidays.co.uk`)}`}
                      target="_blank" rel="noreferrer" className="mb-btn mb-btn-wa">
                      <Ic.WA/> Share Code on WhatsApp
                    </a>
                  </div>
                </>
              )}
              {booking.referral?.discount_available ? (
                <div className="mb-success-pill" style={{marginTop:10}}>You have a £99 discount available — mention it when booking your next holiday!</div>
              ) : null}
            </div>

          </section>

        </div>{/* portal-body */}

        {/* ── Footer strip ───────────────────────────────────────────────── */}
        <div className="mb-footer-strip">
          <img src={logo} alt="Broadway Holidays"/>
          <span>Broadway Holidays © {new Date().getFullYear()}</span>
          <Link to="/">Back to website</Link>
          <button className="mb-link-btn" onClick={() => { setStep('verify'); setBooking(null); setCreds(null); }}>
            Sign out
          </button>
        </div>

      </div>{/* portal */}
    </div>
  );
}